import type { ChatHistoryDetailMessage } from "@/types/chatHistory"
import { DTT_JURISDICTIONS, type DttJurisdiction } from "@/types/jurisdictions"

const KNOWN_JURISDICTIONS = new Set<string>(DTT_JURISDICTIONS)

/** Treaty counterpart from the most recent user message in a loaded chat. */
export function deriveChatFromJurisdiction(
  messages: ChatHistoryDetailMessage[]
): DttJurisdiction | null {
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i]
    if (message.role !== "user") continue
    const from = message.from_jurisdiction?.trim()
    if (!from) return null
    return KNOWN_JURISDICTIONS.has(from) ? (from as DttJurisdiction) : null
  }
  return null
}
